import { Col, Container, Row } from "react-bootstrap";
import { CaretDownFill, CaretRightFill } from "react-bootstrap-icons";

export default function SongHistoryHeader() {
    return (
        <Container fluid className="sticky-top d-flex">
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none flex-nowrap flex-grow-1">
                <Col xs={1} className="min-w-song-history-date-col pe-1 text-center position-sticky start-0 border-end bg-ra-dark-blue">
                    Date <CaretDownFill className=" text-light" /> Hour <CaretRightFill className=" text-light" />
                </Col>
                {Array(24)
                    .fill()
                    .map((_, i) => (
                        <Col xs key={i} className=" text-center px-0 min-w-song-history-hour-col border-start ">
                            {i.toString().padStart(2, 0)}
                        </Col>
                    ))}
            </Row>
        </Container>
    );
}
